import { SelectChangeEvent } from "@mui/material";
import { State } from "../../../redux/slices";
import { useDispatch, useSelector } from "react-redux";

import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  resetAdvancedDeclarationOptionAndDeclarationOptions,
  resetCriteriaToBin,
  resetQualityCriteriaData,
  selecteBinIndex,
  selectedCriteria,
  setAdvancedDeclarationOption,
  setAllotmentPolicies,
  setAvancedDeclarationOptionSelected,
  setCriteriaToBin,
  setCriteriaValuesToDelete,
  setLocationGrainTracker,
  setPrincipalInfoGT,
  setTheBinIsGood,
} from "../../../redux/slices/grainTracker/grainTracker";
import { useEffect } from "react";

import {
  deleteBin,
  updateBin,
} from "../../../redux/actions/GrainWise/grainTracker";

import {
  AddingCriteria,
  AdvancedDeclarationOption,
  LocationGrainTrackerValues,
  PrincipalInfoGT,
} from "../../../redux/slices/grainTracker/grainTrackerTypes";

import {
  advancedDeclarationOption,
  fetchQualityCriteria,
} from "../../../redux/actions/GrainWise/grainTrackerGetServices";

import { DataSBFilterValues } from "../../../redux/actions/dataTable/DataTableTypes";
import GrainTrackerMenuButtons from "../partsOfForm/GrainTrackerMenuButtonsOptions";
import GrainTrackerFormWithCriteria from "../partsOfForm/grainwiseForm/GrainWiseForm";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    setLocationGrainTracker: (graintracker: any) => {
      dispatch(setLocationGrainTracker(graintracker));
    },

    setSpeciePIGT: (principalInfoGT: PrincipalInfoGT, specie: any) => {
      dispatch(setPrincipalInfoGT({ ...principalInfoGT, specie }));
    },
    setNamePIGT: (principalInfoGT: PrincipalInfoGT, name: string) => {
      dispatch(setPrincipalInfoGT({ ...principalInfoGT, name }));
    },

    setStorageIdPIGT: (principalInfoGT: PrincipalInfoGT, id: string) => {
      dispatch(setPrincipalInfoGT({ ...principalInfoGT, storage: id }));
    },
    setTonsPIGT: (principalInfoGT: PrincipalInfoGT, tons: number) => {
      dispatch(setPrincipalInfoGT({ ...principalInfoGT, tonsCapacity: tons }));
    },

    resetBinInformation: (principalInfoGTCopy: PrincipalInfoGT) => {
      dispatch(setPrincipalInfoGT(principalInfoGTCopy));
    },

    updateBin: (token: string) => {
      dispatch(updateBin(token));
    },

    deleteBin: (token: string) => {
      dispatch(deleteBin(token));
    },

    /// quality criteria

    fetchQualityCriteria: (token: string, specie: number) => {
      dispatch(fetchQualityCriteria({ token, specie }));
    },

    setCriteriaToBin: (addingCriteria: AddingCriteria) => {
      dispatch(setCriteriaToBin(addingCriteria));
    },

    resetCriteriaToBin: () => {
      dispatch(resetCriteriaToBin());
      dispatch(resetQualityCriteriaData());
      dispatch(selectedCriteria(undefined));
    },

    selectedCriteriaV: (values: any) => {
      dispatch(selectedCriteria(values));
    },

    setCriteriaValuesToDelete: (values: string[]) => {
      dispatch(setCriteriaValuesToDelete(values));
    },

    resetAllotmentCriteria: () => {
      dispatch(setAllotmentPolicies([]));
      dispatch(resetAdvancedDeclarationOptionAndDeclarationOptions());
    },

    setTheBinIsGood: (value: boolean) => {
      dispatch(setTheBinIsGood(value));
    },

    setAvancedDeclarationOptionSelected: (values: {
      allValuesSelected: boolean;
      valuesSelected: DataSBFilterValues[];
    }) => {
      dispatch(setAvancedDeclarationOptionSelected(values));
    },

    exitEditBinMode: (
      locationGrainTrackerValues: LocationGrainTrackerValues
    ) => {
      dispatch(
        setLocationGrainTracker({
          ...locationGrainTrackerValues,
          isAddingStorage: false,
          isEditingBin: false,
        })
      );
      dispatch(selecteBinIndex(undefined));
      dispatch(setTheBinIsGood(false));
      dispatch(setAllotmentPolicies([]));
      dispatch(resetQualityCriteriaData());
      dispatch(resetAdvancedDeclarationOptionAndDeclarationOptions());
      dispatch(selectedCriteria(undefined));
      dispatch(
        setCriteriaToBin({
          adding: false,
          values: {
            storageInstanceId: "",
            storageQualityCriterionId: "",
            allotmentOperator: "",
            allotmentValue: "",
            allotmentValueArray: [],
          },
        })
      );
    },

    resetAddingCriteria: () => {
      dispatch(selectedCriteria(undefined));
      dispatch(resetAdvancedDeclarationOptionAndDeclarationOptions());
      dispatch(
        setCriteriaToBin({
          adding: false,
          values: {
            storageInstanceId: "",
            storageQualityCriterionId: "",
            allotmentOperator: "",
            allotmentValue: "",
            allotmentValueArray: [],
          },
        })
      );
    },

    advancedDeclarationOptionValues: () => {
      dispatch(advancedDeclarationOption(null));
    },

    setAdvancedDeclarationOptionLoading: (
      advancedDeclarationOption: AdvancedDeclarationOption,
      loading: boolean
    ) => {
      dispatch(
        setAdvancedDeclarationOption({
          ...advancedDeclarationOption,
          loading,
        })
      );
    },
    setAdvancedDeclarationOptionText: (
      advancedDeclarationOption: AdvancedDeclarationOption,
      searchText: string
    ) => {
      dispatch(
        setAdvancedDeclarationOption({
          ...advancedDeclarationOption,
          searchText,
        })
      );
    },
  };
};

export const theBinIsGood = (
  specie: number | undefined | null,
  storage: undefined | string | null,
  tonsCapacity: number | undefined | null
) => {
  if (
    specie !== undefined &&
    storage &&
    tonsCapacity !== 0 &&
    tonsCapacity !== undefined
  ) {
    return false;
  } else {
    return true;
  }
};

export const GrainTrackerForm = (t: (arg0: string) => string) => {
  const {
    setLocationGrainTracker,
    setSpeciePIGT,
    setNamePIGT,
    setStorageIdPIGT,
    setTonsPIGT,
    resetBinInformation,
    updateBin,
    deleteBin,
    fetchQualityCriteria,
    setCriteriaToBin,
    resetCriteriaToBin,
    selectedCriteriaV,
    setCriteriaValuesToDelete,
    resetAddingCriteria,
    resetAllotmentCriteria,
    exitEditBinMode,
    advancedDeclarationOptionValues,
    setAdvancedDeclarationOptionText,
    setAvancedDeclarationOptionSelected,
    setAdvancedDeclarationOptionLoading,
  } = SetActions();

  const { user } = useSelector((state: State) => state.Authentication);

  const {
    locationGrainTrackerValues,
    listOfSpecies,
    principalInfoGT,
    listOfStoragesTemplates,
    principalInfoGTCopy,
    qualityCriteria,
    addingCriteria,
    selectedCriteria,
    advancedDeclarationOption,
    advancedDeclarationOptionSelected,
    selectedCriteriaToDelete,
    allotmentPolicies,
    editBins,
    theBinIsGoodValues,
  } = useSelector((state: State) => state.GrainWiseReducer);

  const { specie, storage, name, tonsCapacity } = principalInfoGT;

  const { isAddingStorage, storagesList, isEditingBin } =
    locationGrainTrackerValues;

  const { storagesTemplates } = listOfStoragesTemplates;

  const { searchText } = advancedDeclarationOption;

  const token = user?.token ?? "";

  const optionByDefultSelect = [
    {
      id: 0,
      slug: "undefined",
      textIdLocale: t("Grain_tracker.species-placeholder"),
    },
  ];

  const addOptionByDefault = optionByDefultSelect.concat(
    listOfSpecies?.speciesTemplates?.data as any
  );

  const addOptionCriteriaByDefault = qualityCriteria.data;

  const setToCancelEditAddStorage = () => {
    resetBinInformation(principalInfoGTCopy);
    setLocationGrainTracker({
      ...locationGrainTrackerValues,
      isAddingStorage: false,
      isEditingBin: false,
    });
    resetCriteriaToBin();
  };

  const handleChangeSpecies = (event: SelectChangeEvent) => {
    setSpeciePIGT(principalInfoGT, event.target.value);
    fetchQualityCriteria(token, event.target.value as any);
  };

  const handleStorageId = (event: SelectChangeEvent) => {
    setStorageIdPIGT(principalInfoGT, event.target.value);
  };

  const selectedCriteriaTemplate = qualityCriteria?.data?.filter(
    (values) => values.id === selectedCriteria
  );

  const selectedSpecie = listOfSpecies?.speciesTemplates?.data?.filter(
    (values) => values.id === principalInfoGT.specie
  )[0];

  const managingTons = principalInfoGT?.tonsCapacity ?? 0;
  const totalTons =
    (selectedSpecie?.conversionFromWheatTons as any) * managingTons;

  useEffect(() => {
    resetBinInformation(principalInfoGTCopy);
    resetCriteriaToBin();
    setCriteriaValuesToDelete([]);

    setTimeout(() => {
      if (principalInfoGTCopy.specie) {
        fetchQualityCriteria(token, principalInfoGTCopy.specie);
      }
    }, 300);
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchText.length < 1) {
        setAvancedDeclarationOptionSelected({
          allValuesSelected: false,
          valuesSelected: [],
        });
      } else {
        setAdvancedDeclarationOptionLoading(advancedDeclarationOption, true);
        advancedDeclarationOptionValues();
      }
    }, 900);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText]);

  const managingOptionToShow = () => {
    if (!isAddingStorage && storagesList.length === 0) {
      return (
        <div className="info-form-text-grain">
          {t("Grain_tracker.add_storage_information")}
        </div>
      );
    }
    if (isAddingStorage || (isEditingBin && storagesList.length >= 1)) {
      return (
        <>
          <GrainTrackerFormWithCriteria
            t={t}
            locationGrainTrackerValues={locationGrainTrackerValues}
            theBinIsGoodValues={theBinIsGoodValues}
            editBins={editBins}
            exitEditBinMode={exitEditBinMode}
            storage={storage}
            handleStorageId={handleStorageId}
            storagesTemplates={storagesTemplates}
            name={name}
            setNamePIGT={setNamePIGT}
            principalInfoGT={principalInfoGT}
            specie={specie}
            handleChangeSpecies={handleChangeSpecies}
            addOptionByDefault={addOptionByDefault}
            tonsCapacity={tonsCapacity}
            setTonsPIGT={setTonsPIGT}
            totalTons={totalTons}
            selectedSpecie={selectedSpecie}
            qualityCriteria={qualityCriteria}
            AllotmentPolicies={allotmentPolicies}
            qualityCriteriaData={qualityCriteria.data}
            setCriteriaValuesToDelete={setCriteriaValuesToDelete}
            selectedCriteriaToDelete={selectedCriteriaToDelete}
            addingCriteria={addingCriteria}
            selectedCriteriaV={selectedCriteriaV}
            setCriteriaToBin={setCriteriaToBin}
            addOptionCriteriaByDefault={addOptionCriteriaByDefault}
            selectedCriteriaTemplate={selectedCriteriaTemplate}
            resetAddingCriteria={resetAddingCriteria}
            setAdvancedDeclarationOptionText={setAdvancedDeclarationOptionText}
            advancedDeclarationOption={advancedDeclarationOption}
            setAvancedDeclarationOptionSelected={
              setAvancedDeclarationOptionSelected
            }
            advancedDeclarationOptionSelected={
              advancedDeclarationOptionSelected
            }
            selectedCriteria={selectedCriteria}
          />

          {/*Buttons options GT */}

          <GrainTrackerMenuButtons
            t={t}
            theBinIsGood={theBinIsGood}
            specie={specie}
            storage={storage}
            tonsCapacity={tonsCapacity}
            updateBin={updateBin}
            token={token}
            isAddingStorage={isAddingStorage}
            setToCancelEditAddStorage={setToCancelEditAddStorage}
            setCriteriaValuesToDelete={setCriteriaValuesToDelete}
            resetAllotmentCriteria={resetAllotmentCriteria}
            deleteBin={deleteBin}
            editedLoading={editBins.editedLoading}
          />
        </>
      );
    } else {
      return (
        <div className="info-form-text-grain">
          {t("Grain_tracker.view_information")}
        </div>
      );
    }
  };

  return (
    <div className="form-graintracker-container">{managingOptionToShow()}</div>
  );
};
